import axios from "axios"
import { BASE_URL } from "../../constants/urls"
import authService from "../authService"
import { getAxiosLang } from "../langStore"

const api = axios.create({
    baseURL: BASE_URL,
})

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.warn("Unauthorized, logging out…")
            authService.logout()
        }
        return Promise.reject(error)
    }
)

api.interceptors.request.use((config) => {
    config.headers['accept-language'] = getAxiosLang();
    return config;
});

export { api }